import { render, staticRenderFns } from "./detail-info.html?vue&type=template&id=409e9074&scoped=true&external"
import script from "./detail-info.js?vue&type=script&lang=js&external"
export * from "./detail-info.js?vue&type=script&lang=js&external"
import style0 from "./detail-info.scss?vue&type=style&index=0&id=409e9074&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "409e9074",
  null
  
)

export default component.exports